<template>
    <header class="header">
        <div class="inner">
            <img class="logo cursor" @click="toHome" src="@/assets/images/logo.png" alt="">
        </div>
    </header>
</template>

<script>
export default {
    name: "Header",
    methods: {
        toHome() {
            this.$router.push({
                name: "constructing",
            });
        },
    }
};
</script>

<style lang="less" scoped>

.header {
    width: 100%;
    height: 100rem;
    background: #000000;
    position: sticky;
    top: 0;
    z-index: 990;

    .inner {
        max-width: 1920px;
        width: 100%;
        height: 100rem;
        margin: 0 auto;
        padding: 0 180rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .logo {
        width: auto;
        height: 36rem;
    }
}
</style>